import { Form, Input } from "antd"
import { Edit3Icon, Mail } from "lucide-react"

import { AUTH_INPUT_BASE_CLASS, AUTH_INPUT_INNER_CLASS } from "./constants"

interface EmailFieldProps {
  readOnly?: boolean
  onEdit?: () => void
}

export default function EmailField({
  readOnly = false,
  onEdit
}: EmailFieldProps) {
  return (
    <Form.Item
      name="_email"
      className="mb-4"
      normalize={(value) => value?.trim()}
      rules={[
        {
          required: true,
          message: "Email Id cannot be Empty"
        },
        {
          type: "email",
          message: "Please enter a valid email"
        }
      ]}
    >
      <Input
        data-testid="auth-email-input"
        placeholder="you@company.com"
        autoComplete="off"
        className={`${AUTH_INPUT_BASE_CLASS} ${readOnly ? "!bg-gray-100 hover:border-gray-300 focus-within:border-gray-300 focus-within:shadow-sm" : "hover:border-gray-400 focus-within:border-primary focus-within:shadow-none"}`}
        classNames={AUTH_INPUT_INNER_CLASS}
        readOnly={readOnly}
        prefix={<Mail size={16} className="text-gray-400 mr-1" />}
        suffix={
          onEdit ? (
            <Edit3Icon
              data-testid="auth-email-edit-button"
              size={16}
              className="cursor-pointer text-gray-400 hover:text-dark"
              onClick={onEdit}
            />
          ) : undefined
        }
      />
    </Form.Item>
  )
}
